import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ADPResourceService } from 'digital-core';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';

@Component({
  selector: 'pgh-perk',
  templateUrl: './perk.component.html',
  styleUrls: ['./perk.component.scss']
})
export class PerkComponent implements OnInit {
  @Input() perk: string;
  @Input() count: number = 0;
  @Input() isPartnerLabelActive: boolean = false;
  @Input() isMobile: boolean = false;
  @Output() tutorialClicked = new EventEmitter();

  openInModal: boolean = false;
  perkSvgIcon: string;
  perkButtonOpenInNewWIndow: boolean = false;
  tutorialOpened: boolean = false;
  perkButtonRoute: string;
  perkButtonAria: string;
  partnerLabel: string;
  perkHeading: string;
  isTutorial: boolean = false;

  constructor(
    private matDialog: MatDialog,
    private preInitSettingsService: PreInitSettingsService,
    private resourceService: ADPResourceService) { }

  ngOnInit(): void {
    this.perkSvgIcon = this.getSetting(this.perk + '_SvgIcon');
    this.perkButtonOpenInNewWIndow = this.getSetting(this.perk + '_Button_OpenInNewWindow').toLowerCase() === 'true';
    this.perkButtonRoute = this.getSetting('URL_' + this.perk);
    if (this.perkButtonRoute === '{tutorial}'){
      this.isTutorial = true;
    }
    this.perkHeading = this.getLabel(this.perk + '_Heading');
    this.perkButtonAria = this.getLabel(this.perk + '_Button');
    this.partnerLabel = this.getLabel(this.perk + '_PartnerLabel');
    if (this.perkButtonRoute.indexOf('{uri}') > -1) {
      this.perkButtonRoute = this.perkButtonRoute.replace('{uri}', encodeURIComponent(this.preInitSettingsService.getSiteSettings().hostName));
    }
  }

  openTutorial() {
    this.tutorialClicked.emit(this.perkButtonAria);
    this.tutorialOpened = true;
  }

  getSetting(name: string): string {
    return this.resourceService.getPortalSetting(name)?.Value
  }

  getLabel(name: string) : string {
    return this.resourceService.getLabel(name);
  }

  handlePerkClick(){

    if(this.isTutorial){
      if(!this.tutorialOpened){
        this.tutorialClicked.emit(this.perkButtonAria);
      }
      else{
        this.tutorialOpened=false;
      }
    }
    else{
      if(this.perkButtonOpenInNewWIndow ){
        window.open(this.perkButtonRoute, '_blank');
      }else{
        window.open(this.perkButtonRoute, '_self');
      }
    }

  }

  handlePerkKeyDown(event:any){
    if(event.keyCode === 13){
      this.handlePerkClick();
    }
  }
}
